import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image-home.svg'


const _withScopeId = n => (_pushScopeId("data-v-1a7fcb56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-welcome" }
const _hoisted_2 = { class: "text-description" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_4 = { class: "text-choice" }

import { ref, onMounted } from "vue";
import { getTestSmells } from "@/services/TestSmellService";
import { TestSmell } from "@/models/TestSmellModel";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { t } = useI18n();
const testSmells = ref<TestSmell[]>([]);

onMounted(async () => {
  testSmells.value = getTestSmells().value;
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "home-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "row-home",
        align: "center",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "left-column"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)("homePage.title")), 1),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("homePage.subtitle")), 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_img, {
                  src: _imports_0,
                  alt: "Bem-vindo",
                  class: "image-home"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "5",
            class: "right-column"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("homePage.chooseSmell")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testSmells.value, (testSmell, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: index,
                  cols: "12",
                  class: "smell-type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/chooseexercise/${testSmell.id}`,
                      class: "link-reset"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          block: "",
                          rounded: "lg",
                          size: "large",
                          class: "green-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(testSmell.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})